import React from "react";
import { Progress, Row, Col } from "antd";
import PropTypes from "prop-types";
import { passwordStrenght } from "../../../utils/utilities";

const PasswordStrenght = ({ password = "" }) => {
  return (
    <Row>
      <Col span={8}>
        <Progress
          percent={passwordStrenght(password) > 0 && password.length > 0 ? 100 : 0}
          size="small"
          strokeColor="red"
          showInfo={false}
        />
      </Col>
      <Col span={8}>
        <Progress
          percent={passwordStrenght(password) > 1 ? 100 : 0}
          size="small"
          strokeColor="yellow"
          showInfo={false}
        />
      </Col>
      <Col span={8}>
        <Progress
          percent={passwordStrenght(password) === 100 ? 100 : 0}
          size="small"
          strokeColor="green"
          showInfo={false}
        />
      </Col>
    </Row>
  );
};

PasswordStrenght.propTypes = {
  password: PropTypes.string,
};

export default PasswordStrenght;
